/// <amd-module name="Mention/AutocompleteResolver/AutocompleteContributionResolverService" />
import { IAutocompleteProvider } from "Mention/Autocomplete/Contracts";
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export const AutocompleteContributionResolverServiceName = "AutocompleteContributionResolverService";

export interface IContributedAutocompleteProvider {
    providerServiceName: string;
    moduleContributionId: string;
}

export interface IAutocompleteContributionResolverService extends IVssService {
    getAutocompleteProviders(): IReadonlyObservableArray<IAutocompleteProvider>;
    getProviderForShortcutCharacter(shortcutCharacter: string): IAutocompleteProvider | undefined;
}

export class AutocompleteContributionResolverService extends VssService implements IAutocompleteContributionResolverService {
    private providers: ObservableArray<IAutocompleteProvider>;
    private providersByShortcut: { [shortcutCharacter: string]: IAutocompleteProvider } = {};

    public getAutocompleteProviders(): IReadonlyObservableArray<IAutocompleteProvider> {
        if (!this.providers) {
            this.providers = new ObservableArray<IAutocompleteProvider>();

            const contributionService = (this.pageContext as IVssPageContext).getService<IVssContributionService>("IVssContributionService");
            const contributions = contributionService.getContributionsByType<IContributedAutocompleteProvider>(
                "ms.vss-mention.mention-autocomplete-provider"
            );

            for (const contributionId of Object.keys(contributions)) {
                const provider: IContributedAutocompleteProvider = contributions[contributionId];

                const contribution = contributionService.getContribution(provider.moduleContributionId);
                if (contribution) {
                    this.addProvider(provider);
                } else {
                    contributionService.getContributionAsync(provider.moduleContributionId).then(c => {
                        this.addProvider(provider);
                    });
                }
            }
        }

        return this.providers;
    }

    public getProviderForShortcutCharacter(shortcutCharacter: string): IAutocompleteProvider | undefined {
        return this.providersByShortcut[shortcutCharacter];
    }

    private addProvider(provider: IContributedAutocompleteProvider) {
        const service = this.pageContext.getService<IAutocompleteProvider>(provider.providerServiceName);
        if (service) {
            this.providers.push(service);
            if (service.shortcutCharacter) {
                this.providersByShortcut[service.shortcutCharacter] = service;
            }
        }
    }
}

export function getAutocompleteProviders(pageContext: IVssPageContext): IReadonlyObservableArray<IAutocompleteProvider> {
    const controllerResolverService = pageContext.getService<IAutocompleteContributionResolverService>(AutocompleteContributionResolverServiceName);
    return controllerResolverService.getAutocompleteProviders();
}

export function getProviderForShortcutCharacter(pageContext: IVssPageContext, shortcutCharacter: string): IAutocompleteProvider | undefined {
    const controllerResolverService = pageContext.getService<IAutocompleteContributionResolverService>(AutocompleteContributionResolverServiceName);
    return controllerResolverService.getProviderForShortcutCharacter(shortcutCharacter);
}

Services.add(AutocompleteContributionResolverServiceName, { serviceFactory: AutocompleteContributionResolverService });
